/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'sso-policy';
const componentName = 'sso-policy-list';
const prefix = `${moduleName}.${componentName}`;

export const headerLabel = `${prefix}.headerLabel`;
export const columnTitleAuthProfile = `${prefix}.columnTitleAuthProfile`;

export const ENGLISH = {
    [headerLabel]: 'SSO Policy',
    [columnTitleAuthProfile]: 'Auth Profile',
};

